/**
 * @fileoverview One commercial-offer select, shown only when the company owns the field.
 * @module components/AppointmentRegistrationSections/CommercialOffer/CommercialOfferSelectField
 */
import Select from "react-select";
import { getSelectedOption, getSelectStylesWithError } from "../../../utils/common";

const CommercialOfferSelectField = ({
  company,
  fieldKey,
  label,
  placeholder,
  options,
  value,
  onChange,
  missingRequiredFields,
  getFieldValidation,
  styles,
}) => {
  if (!company || !Object.hasOwn(company, fieldKey)) {
    return null;
  }

  const showRequired =
    missingRequiredFields && Object.hasOwn(missingRequiredFields, fieldKey);
  const hasError = Boolean(getFieldValidation && getFieldValidation(fieldKey));

  return (
    <div className={styles.inputGroup}>
      <label className={styles.inputLabel}>
        {label}
        {showRequired && <span className={styles.required}> *</span>}
      </label>
      <Select
        value={getSelectedOption(options, value)}
        options={options}
        placeholder={placeholder}
        styles={getSelectStylesWithError(hasError)}
        className="select__control"
        onChange={onChange}
      />
    </div>
  );
};

export default CommercialOfferSelectField;
